import { z } from 'zod';
/**
 * Where one step's effective capacity came from. A source is added here, in
 * {@link SOURCE_CONFIDENCE} and in the chains below — nowhere else.
 */ export const CapacitySourceSchema = z.enum([
    'survey',
    'manual'
]);
/**
 * The tenant-wide "Kapazitätsquelle" setting: which source wins per step, and
 * whether the loser may stand in when the winner has no value.
 */ export const CapacityPrioritySchema = z.enum([
    'survey-first',
    'manual-first',
    'survey-only',
    'manual-only'
]);
export const DEFAULT_CAPACITY_PRIORITY = 'survey-first';
const SOURCE_CHAINS = {
    'survey-first': [
        'survey',
        'manual'
    ],
    'manual-first': [
        'manual',
        'survey'
    ],
    'survey-only': [
        'survey'
    ],
    'manual-only': [
        'manual'
    ]
};
/**
 * The ordered source chain: the calculator walks it per step and takes the
 * first source that has a value. The single derivation, shared by both sides of
 * the wire, so nobody re-derives the fallback order by hand.
 */ export function readCapacityPriority(settings) {
    return SOURCE_CHAINS[settings?.capacityPriority ?? DEFAULT_CAPACITY_PRIORITY];
}

//# sourceMappingURL=capacity-priority.js.map